module.exports = __webpack_public_path__ + "img/Exhibition_Logo.3a0c1810.jpg";